module.exports = __webpack_public_path__ + "img/placeholder.2a5d8e86.svg";